var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgValidTicket = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4237 18.4639L4.92896 16.2957C4.63762 16.1797 4.40743 15.962 4.28835 15.6898C4.16926 15.4176 4.17089 15.1129 4.29288 14.8419L4.88836 13.5886L9.4357 3.67489C9.56095 3.40509 9.79605 3.19192 10.09 3.08163C10.3839 2.97135 10.7129 2.97286 11.0056 3.08583L12.1019 3.56209C11.9995 3.76498 11.9428 3.985 11.935 4.20881C11.9272 4.43263 11.9686 4.65557 12.0566 4.86415C12.1446 5.07272 12.2774 5.26258 12.4469 5.42222C12.6165 5.58186 12.8193 5.70796 13.043 5.79288C13.2668 5.8778 13.5068 5.91977 13.7486 5.91625C13.9904 5.91273 14.2289 5.86379 14.4496 5.7724C14.6704 5.681 14.8688 5.54906 15.0329 5.38456C15.1969 5.22006 15.3232 5.02643 15.4041 4.8154L16.5545 5.25405C16.8262 5.37888 17.0371 5.59407 17.145 5.85661C17.2529 6.11916 17.2498 6.40974 17.1364 6.67029L15.0329 11.0526",
    stroke: "#767380",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6656 18.7281L12.3082 16.6543C11.8972 16.2926 11.8973 15.7063 12.3084 15.3447C12.7196 14.9831 13.386 14.9832 13.797 15.3449L15.297 16.664L18.1055 13.3703C18.3312 13.1057 18.7002 12.9671 19.0735 13.0067C19.4468 13.0463 19.7678 13.2581 19.9154 13.5623C20.0631 13.8666 20.0151 14.217 19.7894 14.4816L16.2524 18.6293C16.0694 18.8443 15.7892 18.9787 15.4847 18.9977C15.1801 19.0167 14.8812 18.9183 14.6656 18.7281Z",
    fill: "#767380"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgValidTicket, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/validTicket.6462e887.svg";
export { ForwardRef as ReactComponent };